export const VICINITIES = {
  Arvada: 'Arvada, Colorado',
  Aurora: 'Aurora, Colorado',
  Boulder: 'Boulder, Colorado',
  Broomfield: 'Broomfield, Colorado',
  Carlsbad: 'Carlsbad, California',
  'Chula Vista': 'Chula Vista, California',
  'Colorado Springs': 'Colorado Springs, Colorado',
  'Commerce City': 'Commerce City, Colorado',
  Coronado: 'Coronado, California',
  Denver: 'Denver, Colorado',
  Englewood: 'Englewood, California',
  Erie: 'Erie, Colorado',
  Evergreen: 'Evergreen, Colorado',
  'Greenwood Village': 'Greenwood Village, Colorado',
  Hialeah: 'Hialeah, Florida',
  'Imperial Beach': 'Imperial Beach, California',
  Lafayette: 'Lafayette, Colorado',
  Lakewood: 'Lakewood, Colorado',
  Littleton: 'Littleton, Colorado',
  'Lone Tree': 'Lone Tree, Colorado',
  Longmont: 'Longmont, Colorado',
  Louisville: 'Louisville, Colorado',
  Lyons: 'Lyons, Colorado',
  Nederland: 'Nederland, Colorado',
  Quincy: 'Quincy, Washington',
  'San Diego': 'San Diego, California',
  'San Marcos': 'San Marcos, California',
  Superior: 'Superior, Colorado',
  Thornton: 'Thornton, Colorado',
  Vail: 'Vail, Colorado',
  Westminster: 'Westminster, Colorado',
  'Wheat Ridge': 'Wheat Ridge, Colorado',
};
